import { render, staticRenderFns } from "./CellRendererDemand.vue?vue&type=template&id=0d80ef0c"
import script from "./CellRendererDemand.vue?vue&type=script&lang=js"
export * from "./CellRendererDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports